<template>
  <div id="app">
    <router-view name="header" />
    <!-- <NavBar/> -->
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
  </div>
</template>
<script>
// import NavBar from './layout/MainNavbar.vue';
export default {
   components: {
    //  NavBar
   }
};
</script>
